import { Component, ElementRef, HostListener, inject, input, output, signal, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule, ChevronsUpDown, UserRound, LogOut } from 'lucide-angular';
import { UsuarioService } from '../../../../services/usuario.service';
import { SidebarService } from '../../../../services/sidebar.service';

@Component({
  selector: 'app-user-account-menu',
  imports: [RouterLink, LucideAngularModule],
  templateUrl: './user-account-menu.component.html',
  styleUrls: ['./user-account-menu.component.scss'],
})
export class UserAccountMenuComponent {
  private readonly users = inject(UsuarioService);
  private readonly navigation = inject(SidebarService);
  private readonly element: ElementRef<HTMLElement> = inject(ElementRef);
  readonly compact = input(false);
  readonly header = input(false);
  readonly opening = output<void>();
  readonly isOpen = signal(false);
  readonly icons = { ChevronsUpDown, UserRound, LogOut };
  @ViewChild('trigger') trigger?: ElementRef<HTMLButtonElement>;
  get usuario() { return this.users.usuario; }
  get profileRoute(): string { return this.navigation.currentUrl().startsWith('/eco/') ? '/eco/perfil' : '/uco/perfil'; }

  // Moved from KiteNavbar: keep the existing initials fallback and logout contract.
  getUserInitials(): string {
    const names = this.usuario?.name?.trim().split(/\s+/).filter(Boolean) || [];
    if (!names.length) return 'U';
    return (names[0][0] + (names.length > 1 ? names[names.length - 1][0] : '')).toUpperCase();
  }
  toggle(): void {
    if (this.isOpen()) { this.close(); return; }
    this.opening.emit(); this.isOpen.set(true);
    setTimeout(() => { if (this.isOpen()) this.element.nativeElement.querySelector<HTMLElement>('.account-panel a')?.focus(); });
  }
  close(restoreFocus = false): void {
    this.isOpen.set(false);
    if (restoreFocus) this.trigger?.nativeElement.focus();
  }
  logout(): void {
    this.close(); this.navigation.closeMobile(false); this.users.logout();
  }
  @HostListener('document:click', ['$event']) outside(event: MouseEvent): void {
    if (!this.element.nativeElement.contains(event.target as Node)) this.close();
  }
}
